import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import type { VehiclePurchaseInfoType } from './useVehicle';

export const PURCHASE_STATE_TYPES_QUERY = '/api/vehicle/:branchId/purchase-info/types';

export interface PurchaseInfoItem {
  ofType: VehiclePurchaseInfoType;
}

interface PurchaseTypesResponse {
  purchaseInfos: PurchaseInfoItem[];
}

const usePurchaseInfoTypes = (): [PurchaseInfoItem[] | undefined, RequestStateQuery] => {
  const { getToken } = useAuth();

  const { data, isLoading, isSuccess, isError } = useQuery<ApiResponse<PurchaseTypesResponse>>({
    queryKey: [PURCHASE_STATE_TYPES_QUERY],
    queryFn: async () =>
      await getJSON<ApiResponse<PurchaseTypesResponse>>(
        '/api/vehicle/purchase-info/types',
        getToken()!,
      ),
  });
  return [data?.response?.purchaseInfos, { isLoading, isSuccess, isError }];
};

export default usePurchaseInfoTypes;
